<template>
  <div id="c-lead" class="c-lead">
    <ul :style="styleObject" class="c-lead__slide">
      <li v-for="imgsrc in bgImgs">
        <img :src="imgsrc" alt="" />
      </li>
    </ul>
    <div id="c-lead__info" class="c-lead__info">
      <h2><img :src="`${$store.getters.assetsPath}img/top/lead/title@2x.png`" alt="LUXURY LINE" width="551" height="56" /></h2>
      <template v-if="$store.getters.lang === 'en'">
      <p>The luxury line of the Four Nines. </p>
      <p>It is an elegant eyewear that combines <br class="u-none-b--sp">the functionality </p>
      <p>and quality that Four Nines has cultivated <br class="u-none-b--sp">with special materials.</p>
      <p>The appeal of each material and </p>
      <p>the impressive frame balancing <br class="u-none-b--sp">contributed to the ultimate comfort. </p>
      <p>A one-of-a-kind master piece that gives you</p>
      <p>“The joy of owning” <br class="u-none-b--sp">and “The joy of wearing”, <br>brings comfort and invites people <br class="u-none-b--sp">into a new universe.</p>
      </template>
      <template v-else>
      <p>フォーナインズのラグジュアリーライン。</p>
      <p>それは、フォーナインズが培ってきた<br class="u-none-b--sp" />機能性や品質と、</p>
      <p>特別な素材を融合させた、<br class="u-none-b--sp" />気品溢れるアイウェアです。</p>
      <p>それぞれの素材が持つ魅力と、最上の<br class="u-none-b--sp" />フレームバランスが、</p>
      <p>極上の掛け心地を実現。</p>
      <p>所有欲を刺激し、心地よさをもたらす<br class="u-none-b--sp" />唯一無二の逸品が、</p>
      <p>人々を新たな世界にいざないます。</p>
      </template>
    </div>
  </div>
</template>

<script>
import { gsap, Quart } from 'gsap';

export default {
  data() {
    return {
      bgMax: 3,
      bgImgs: [],
      styleObject: {},
    }
  },
  computed: {
  },
  mounted() {
    // 背景の画像をループ用に増やす
    for (let i = 1; i <= this.bgMax; i++) {
      this.bgImgs.push(`${this.$store.getters.assetsPath}img/top/lead/bg${i}.jpg`);
    }
    this.bgImgs = this.bgImgs.concat(this.bgImgs);
  },
  methods: {}
}
</script>